import React from 'react';
import { Box, Chip, Stack } from '@mui/material';
import { SaleType } from '../types';

export type FilterOption = 
  | 'all' 
  | 'this_weekend' 
  | 'estate_sale' 
  | 'moving_sale' 
  | 'multi_family';

interface FilterChipsProps {
  selectedFilter: FilterOption;
  onFilterChange: (filter: FilterOption) => void;
}

const FILTER_OPTIONS: { value: FilterOption; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'this_weekend', label: 'This Weekend' },
  { value: 'estate_sale', label: 'Estate Sales' },
  { value: 'moving_sale', label: 'Moving Sales' },
  { value: 'multi_family', label: 'Multi-Family' },
];

const FilterChips: React.FC<FilterChipsProps> = ({ 
  selectedFilter, 
  onFilterChange 
}) => {
  const getChipStyle = (filter: FilterOption) => {
    const isSelected = selectedFilter === filter;
    
    if (isSelected) {
      return {
        bgcolor: 'primary.main',
        color: 'white',
        fontWeight: 600,
        '&:hover': {
          bgcolor: 'primary.dark',
        },
      };
    }
    
    return {
      bgcolor: 'background.default',
      color: 'text.secondary',
      fontWeight: 500,
      border: '1px solid',
      borderColor: 'divider',
      '&:hover': {
        bgcolor: 'grey.100',
      },
    };
  };

  return (
    <Box 
      sx={{ 
        width: '100%',
        overflowX: 'auto',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
        py: 1,
      }}
    >
      <Stack 
        direction="row" 
        spacing={1}
        sx={{ px: 2 }}
      >
        {FILTER_OPTIONS.map((option) => (
          <Chip
            key={option.value}
            label={option.label}
            onClick={() => onFilterChange(option.value)}
            sx={{
              ...getChipStyle(option.value),
              flexShrink: 0,
              borderRadius: 2,
              px: 1,
            }}
          />
        ))}
      </Stack>
    </Box>
  );
};

export default FilterChips;
